import React from "react";
import { ITilesData } from "../../exports/interfaces";
// import DynamicToolTip from "../DynamicToolTip";
import { Fade } from "react-awesome-reveal";
import { marked } from "marked";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";

const Tiles = (props: { tilesData: ITilesData[] }) => {
  const mobile = useMobile();
  const tab = useTab();
  return (
    <section className="feature-two">
      <div className="container">
        <div className="feature-two__inner">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "space-evenly" }}
          >
            <div className="col-xl-6 col-lg-6" style={{ height: "100%" }}>
              <div
                className="feature-two__single wow fadeInUp"
                data-wow-delay="100ms"
              >
                <Fade cascade damping={0.2} triggerOnce={true}>
                  <div
                    className="feature-two__img"
                    style={{
                      backgroundImage:
                        props?.tilesData[0]?.first_image[0]?.media?.url &&
                        `url(${process.env.REACT_APP_cmsUrl}/uploads/${props?.tilesData[0]?.first_image[0]?.media?.name})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div
                      className="feature-two__content"
                      style={{
                        justifyContent: mobile || tab ? "center" : "start",
                      }}
                    >
                      <h3 className="feature-two__title">
                        <span className="icon-solidarity custom-tiles-icon"></span>
                        {props?.tilesData[0]?.first_title}
                      </h3>
                      <p
                        className="feature-two__text"
                        dangerouslySetInnerHTML={{
                          __html: marked(
                            props?.tilesData[0]?.first_description || "",
                          ) as string,
                        }}
                      ></p>
                      {/* {(mobile || tab) && (
                        <DynamicToolTip title="Know More">
                          <a href="/about" className="feature-two__arrow">
                            <span className="icon-right-arrow"></span>
                          </a>
                        </DynamicToolTip>
                      )} */}
                    </div>
                    {/* {!mobile && !tab && (
                      <DynamicToolTip title="Know More">
                        <a
                          href="/about"
                          className="feature-two__arrow custom-feature-two__arrow"
                        >
                          <span className="icon-right-arrow"></span>
                        </a>
                      </DynamicToolTip>
                    )} */}
                  </div>
                </Fade>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div
                className="feature-two__single wow fadeInUp"
                data-wow-delay="200ms"
              >
                <Fade cascade damping={0.2} delay={200} triggerOnce={true}>
                  <div
                    className="feature-two__img feature-two__img-2"
                    style={{
                      backgroundImage:
                        props?.tilesData[0]?.second_image[0]?.media?.url &&
                        `url(${process.env.REACT_APP_cmsUrl}/uploads/${props?.tilesData[0]?.second_image[0]?.media?.name})`,
                      backgroundSize: "cover",
                      backgroundPosition: "top",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div
                      className="feature-two__content"
                      style={{
                        justifyContent: mobile || tab ? "center" : "start",
                      }}
                    >
                      <h3 className="feature-two__title">
                        <span className="icon-sponsor custom-tiles-icon"></span>
                        {props?.tilesData[0]?.second_title}
                      </h3>
                      <p
                        className="feature-two__text"
                        dangerouslySetInnerHTML={{
                          __html: marked(
                            props?.tilesData[0]?.second_description || "",
                          ) as string,
                        }}
                      ></p>
                      {/* {(mobile || tab) && (
                        <DynamicToolTip title="Know More">
                          <a href="/about" className="feature-two__arrow">
                            <span className="icon-right-arrow"></span>
                          </a>
                        </DynamicToolTip>
                      )} */}
                    </div>
                    {/* {!mobile && !tab && (
                      <DynamicToolTip title="Know More">
                        <a
                          href="/about"
                          className="feature-two__arrow custom-feature-two__arrow"
                        >
                          <span className="icon-right-arrow"></span>
                        </a>
                      </DynamicToolTip>
                    )} */}
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tiles;
